import React, { useEffect, useRef } from 'react';
import './services.css';
import CyberSecurity from '../../assets/cybersecurity.png';
import Coding from '../../assets/coding.png';
import Video from '../../assets/video.png';

const services = [
  {
    id: 1,
    icon: '🛡️',
    title: 'Cyber Security',
    image: CyberSecurity,
    description: 'Protect your digital fortress with comprehensive security solutions. From vulnerability assessment to penetration testing, we strengthen your online presence against evolving threats.',
    features: ['Vulnerability Assessment', 'Penetration Testing', '24/7 Monitoring'],
    color: '#f59e0b'
  },
  {
    id: 2,
    icon: '⚡',
    title: 'Full Stack Development',
    image: Coding,
    description: 'Build scalable web applications with modern technologies. From concept to deployment, we create dynamic platforms that engage users and drive business growth.',
    features: ['Frontend Development', 'Backend Architecture', 'API Integration'],
    color: '#6366f1'
  },
  {
    id: 3,
    icon: '🎥',
    title: 'Content Creation',
    image: Video,
    description: 'Creating free programming and cybersecurity content for YouTube and Instagram. No corporate fluff — just practical knowledge to help you grow as a developer.',
    features: ['Programming Tutorials', 'Cybersecurity Tips', 'Social Media Education'],
    color: '#ec4899'
}
];

const Services = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = document.querySelectorAll('.service-card');
    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="services" id="services" ref={sectionRef}>
      <div className="services__container">
        {/* Header */}
        <div className="services__header">
          <span className="services__badge">What I Do</span>
          <h2 className="services__title">
            My <span className="gradient-text">Services</span>
          </h2>
          <div className="services__underline"></div>
          <p className="services__subtitle">
            Transforming ideas into exceptional digital experiences
          </p>
        </div>

        {/* Services Grid */}
        <div className="services__grid">
          {services.map((service) => (
            <div 
              key={service.id} 
              className="service-card"
              style={{ '--card-color': service.color }}
            >
              <div className="service-card__inner">
                {/* Icon */}
                <div className="service-card__icon">
                  <span className="icon-emoji">{service.icon}</span>
                </div>

                {/* Image */}
                <div className="service-card__image-wrapper">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="service-card__image"
                  />
                  <div className="service-card__image-glow"></div>
                </div>

                {/* Content */}
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__description">{service.description}</p>

                {/* Features */}
                <div className="service-card__features">
                  {service.features.map((feature, idx) => (
                    <span key={idx} className="feature-tag">
                      <span className="feature-dot"></span>
                      {feature}
                    </span>
                  ))}
                </div>

                {/* Learn More Link */}
                <a href="#contact" className="service-card__link">
                  <span>Learn More</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="services__stats">
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">Projects Delivered</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">100+</span>
            <span className="stat-label">Happy Clients</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">4.9/5</span>
            <span className="stat-label">Average Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;